import { Route } from '@angular/router';

import { VerifyOtpComponent } from './verify-otp.component';

export const verifyOtpRoute: Route = {
    path: 'verificaOtp',
    component: VerifyOtpComponent,
    data: {
        pageTitle: 'pagetitles.verifyotp'
    }
};
